import React from "react";
import { toggleSidebar, slideNav } from "../common/utils/common";

class Sidebar extends React.Component {
    render() {
        return (
            <div>
                <div id="site-sidebar">
                    <div className="sidebar-header">
                        <a href="https://www.us-immigration.com/">
                            <img src="/assets-static/images/logo-en.png" title="American Immigration" alt="American Immigration"/>
                        </a>
                    </div>
                    <nav className="sidebar-menu">

                        <a onClick={(e) => slideNav(e, 0)} id="0" className="link-primary ddm-link">U.S. Citizenship</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.us-immigration.com/us-citizenship-and-naturalization-application/">
                                        U.S. Citizenship Application<br/><strong>Form N-400</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/certificate-of-citizenship-n-600/">
                                        Certificate of Citizenship<br/><strong>Form N-600</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/replace-certificate-of-citizenship-form-n565/">
                                        Replace Certificate of Citizenship<br/><strong>Form N-565</strong>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 1)} id="1" className="link-primary ddm-link">Green Card</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.us-immigration.com/replace-lost-stolen-green-card-form-I-90/">
                                        Green Card Renewal<br/><strong>Form I-90</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/replace-lost-stolen-green-card-form-I-90/">
                                        Green Card Replacement<br/><strong>Form I-90</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/get-green-card-through-family-member/">
                                        Green Card through Family<br/><strong>Form I-130</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/Adjustment-of-Status-Form-I-485/">
                                        Adjustment of Status<br/><strong>Form I-485</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/form-i751-remove-conditions-green-card/">
                                        Remove Conditions on Green Card<br/><strong>Form I-751</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/form-I-131-application-travel-document/">
                                        Application for Travel Document<br/><strong>Form I-131</strong>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://app.us-immigration.com/green-card-expiration-reminder-service/">
                                        Green Card Expiration Service
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 2)} id="2" className="link-primary ddm-link">U.S. Visas</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.us-immigration.com/visa-availability-checker/">
                                        Visa Availability Checker
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/k1-fiancee-visa/">
                                        K-1 Fiancé(e) Visa
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/immigration-forms/">
                                        All U.S. Visas Forms
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 3)} id="3" className="link-primary ddm-link">Employment</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.us-immigration.com/form-i765-employment-authorization/">
                                        Employment Authorization Card Renewal (EAD)
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a href="https://www.us-immigration.com/immigration-forms/" className="link-primary">Immigration Forms</a>

                        <a onClick={(e) => slideNav(e, 4)} id="4" className="link-primary ddm-link">USCIS</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://app.us-immigration.com/case-status/">
                                        Case Status
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.us-immigration.com/infopass/">
                                        Infopass
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 5)} id="5" className="link-primary ddm-link">Resources</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.us-immigration.com/blog/">
                                        US Immigration Blog
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a href="/registration/logincheck.do?next=/application-center/applicationcenter.do&amp;lang=en" className="link-secondary">My Account</a>

                    </nav>
                </div>
                <div id="faded-bg" onClick={() => toggleSidebar()}>&nbsp;</div>
            </div>
        );
    }
}

export default Sidebar;
